import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../../../constants/size'
import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import { QA_NAME_INTEGRATIONS_IMPORT_RUN_REPROCESS } from '../IntegrationsImportLog.constants'

import { getReprocessDescription } from './IntegrationsReprocessModal.utils'

function IntegrationsReprocessModal({ run, onCancel, onSubmit }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  return (
    <ConfirmationModal
      actionButtonsProps={{
        submitText: t('RentalPortal.IntegrationsRunReprocessKey'),
      }}
      boxSize={SIZE.LARGE}
      description={getReprocessDescription({ locale, run, t, timezone })}
      qaName={QA_NAME_INTEGRATIONS_IMPORT_RUN_REPROCESS}
      title={t('RentalPortal.IntegrationsRunReprocessTitleKey')}
      onCancel={onCancel}
      onSubmit={onSubmit}
    />
  )
}

export default IntegrationsReprocessModal
